var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.67822 2.89212L13.6782 2.89212V8.89212C13.6782 9.4444 14.1259 9.89212 14.6782 9.89212H20.6782V24.8921H2.67822L2.67822 2.89212ZM15.6782 4.30633L19.264 7.89212H15.6782V4.30633ZM22.6782 24.8921V8.90002V8.89212C22.6782 8.85066 22.6756 8.80946 22.6706 8.76874L22.6782 8.90002L14.6704 0.892119C14.7169 0.891764 14.7632 0.894653 14.8091 0.90072C14.766 0.895021 14.7222 0.892119 14.6782 0.892119H14.6704H2.67822C2.14779 0.892119 1.63908 1.10283 1.26401 1.47791C0.888937 1.85298 0.678223 2.36169 0.678223 2.89212V24.8921C0.678223 25.4226 0.888936 25.9313 1.26401 26.3063C1.63908 26.6814 2.14779 26.8921 2.67822 26.8921H20.6782C21.2087 26.8921 21.7174 26.6814 22.0924 26.3063C22.4675 25.9313 22.6782 25.4226 22.6782 24.8921ZM14.9272 0.923598C15.0991 0.967791 15.2577 1.05737 15.3853 1.18501C15.2559 1.0556 15.097 0.967235 14.9272 0.923598ZM11.1782 13.8921C9.79751 13.8921 8.67822 15.0114 8.67822 16.3921C8.67822 17.7728 9.79751 18.8921 11.1782 18.8921C12.5589 18.8921 13.6782 17.7728 13.6782 16.3921C13.6782 15.0114 12.5589 13.8921 11.1782 13.8921ZM6.67822 16.3921C6.67822 13.9068 8.69294 11.8921 11.1782 11.8921C13.6635 11.8921 15.6782 13.9068 15.6782 16.3921C15.6782 17.2726 15.4253 18.0941 14.9882 18.7878L16.3854 20.1851C16.776 20.5756 16.776 21.2088 16.3854 21.5993C15.9949 21.9898 15.3617 21.9898 14.9712 21.5993L13.574 20.202C12.8802 20.6392 12.0588 20.8921 11.1782 20.8921C8.69294 20.8921 6.67822 18.8774 6.67822 16.3921Z",
    fill: "url(#paint0_linear_191_2767)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_191_2767",
    x1: 0.678223,
    y1: 0.89209,
    x2: 21.7135,
    y2: 26.4254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE49D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FED961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FEE180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFE99D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFCA47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.a05bd0c5760f7526f0e226ce173c0fa3.svg";
export { ForwardRef as ReactComponent };